import { InstanceData, InstanceDataType } from '@/framework/data';
import { StageServer } from './stage-server';

export class Stage extends StageServer {
    constructor(identity: string) {
        super(identity);
    }

    destroy() {
        super.destroy();
    }
}

export function getStageInstance(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.Stage) as Stage;
}
